import StoreInfoModalContainer from 'components/store-info-modal';

export default function StoreDetailsByIdPage() {
  return <StoreInfoModalContainer />;
}
